import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import * as Api from "@/api";
import Search from "@/design/components/Search";
import useSearch from "@/utils/hooks/useSearch";
import Valkyrie, { viPlus, viXmark } from "@sippy-platform/valkyrie";

import { Alert, Box, Button, Drawer, IconButton, List, ListItem, ListItemText, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import HolidaySetItem from "./AddHolidaySetItem";

function HolidaySets({ timetable, timetableDispatch }) {
  const holidaySetStore = useSelector((state) => state.domain.holidaySets);

  // Fetch data from API
  useEffect(() => {
    Promise.resolve(Api.getHolidaySets());
  }, []);

  // HolidaySet drawer
  const [drawer, setDrawer] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  const searchResults = useSearch(holidaySetStore.list, searchValue, ["name"]);

  const closeDrawer = useCallback(() => {
    setDrawer(undefined);
    setSearchValue("");
  }, []);

  return (
    <>
      <Button
        onClick={() => setDrawer(true)}
        variant="contained"
        id="addHolidaySet"
        disabled={timetable.holidaySets.length >= 4}
        startIcon={<Valkyrie icon={viPlus} />}
      >
        Add
      </Button>
      <Drawer
        open={!!drawer}
        onClose={() => closeDrawer()}
        anchor="right"
        slotProps={{
          paper: {
            sx: (theme) => ({ maxWidth: 320, width: 1, p: 1.5, display: "flex", gap: 1, ...theme.scrollbar }),
            elevation: 4,
          },
        }}
      >
        <Stack
          direction="row"
          sx={{
            gap: 1,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">Add holiday set</Typography>
          <IconButton onClick={() => closeDrawer()} color="inherit">
            <Valkyrie icon={viXmark} />
          </IconButton>
        </Stack>
        <Box sx={{ position: "sticky", top: 0, zIndex: 1000 }}>
          <Search blur value={searchValue} onChange={setSearchValue} />
        </Box>
        {timetable.holidaySets.length >= 4 && (
          <Alert severity="info">You have reached the limit of 4 holiday sets.</Alert>
        )}
        <List>
          {searchResults.length >= 1 ? (
            searchResults.map((holidaySet) => (
              <HolidaySetItem
                key={holidaySet.id}
                holidaySet={holidaySet}
                timetableDispatch={timetableDispatch}
                timetable={timetable}
              />
            ))
          ) : (
            <ListItem>
              <ListItemText primary="There are no holiday sets available..." />
            </ListItem>
          )}
        </List>
      </Drawer>
    </>
  );
}

HolidaySets.propTypes = {
  timetable: PropTypes.object,
  timetableDispatch: PropTypes.func,
};

export default HolidaySets;
